module.exports = "<div class=\"alphabet-search\">\r\n    <button  (click)=\"click_search()\" class=\"btn btn-link all alphabet {{!alpha ? 'alphabet-search-active' : ''}}\">All</button>\r\n    <button *ngFor=\"let item of data\" (click)=\"click_search(item)\" class=\"btn btn-link alphabet {{alpha == item ? 'alphabet-search-active' : ''}}\">{{item}}</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/component/alphasearch/alphasearch.component.html
// module id = ./src/app/common/component/alphasearch/alphasearch.component.html
// module chunks = common